goog.provide('el8.app.onboarding.learnMore');

goog.require('el8.app.onboarding.TestAccountDialog');
goog.require('el8.template.app.onboarding.learnMore');
goog.require('el8.app.onboarding.activateAccount');
goog.require('el8.uiwidget.Form');



el8.app.onboarding.learnMore = (function() {

    var that = new el8.app.onboarding.TestAccountDialog({
        autoHeight: true,
        position: 'center',
        width: 500,
        modal: true,
        title: 'Want to Learn More?',
        contentFn: el8.template.app.onboarding.learnMore.content,
        showXButton: true
    });

    var super_show = that.show;
    that.show = function() {
        super_show.call(that);
        that._showFreshForm();
    };

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._bindTriggers();
    };

    that._bindTriggers = function() {
        that.getContentElt().on('click', '.submit-trigger',  function() {
            that._submitRequest();
        }).on('click', '.activate-account-trigger',  function() {
            that.hide();
            el8.app.onboarding.activateAccount.show();
        }).on('click', '.reset-form-trigger',  function() {
            that._showFreshForm();
        }).on('click', '.external-site-trigger',  function() {
            window.open('http://www.elationemr.com/?utm_campaign=in_app&amp;utm_source=learn_more');

            // let the sales team the user was exploring here
            var mapped = that._form.getMapped();
            mapped['form_submitted'] = false;
            $.el8_ajax({
                type: 'POST',
                url: '/requestSalesInfo/',
                data: JSON.stringify(mapped)
            });
        });
    };

    that._submitRequest = function() {
        if (that._form) {
            var mapped = that._form.getMapped();

            mapped['utm_campaign'] = '1.passport.learnMore';
            mapped['utm_medium'] = 'emr';
            mapped['utm_source'] = 'el8';
            mapped['utm_content'] = 'banner';

            mapped['form_submitted'] = true;
            that._showInProgress();
            $.el8_ajax({
                type: 'POST',
                url: '/requestSalesInfo/',
                data: JSON.stringify(mapped),
                success: function() { that._showSuccess(); },
                error: function() { that._showError(); }
            });
        }
    };

    /**
     * Helper methods
     */
    that._showFreshForm = function() {
        $('#learn-more-container', that.getContentElt()).html(
            el8.template.app.onboarding.learnMore.requestForm()
        ).removeClass('imageLoading');
        that._form = new el8.uiwidget.Form({
            container: $('form', that.getContentElt()),
            fields: [
                {
                    name: 'name',
                    selector: ':input[name="name"]',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT
                },
                {
                    name: 'email',
                    selector: ':input[name="email"]',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT
                },
                {
                    name: 'phone',
                    selector: ':input[name="phone"]',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT
                },
                {
                    name: 'message',
                    selector: ':input[name="message"]',
                    height: 3 * el8.util.consts.DEFAULT_FIELD_HEIGHT
                }
            ]
        });
        that._form.render();
        var currPhysician = el8.data.physicians.getById(el8.data.currUser.getStaffId());
        that._form.populate({
            name: el8.data.currUser.getFullName(),
            email: el8.data.currUser.getEmail(),
            phone: currPhysician.getPhone()
        });
        that.adjustPosition();
    };
    that._showInProgress = function() {
        $('#learn-more-container', that.getContentElt()).empty().addClass('imageLoading');
    };
    that._showSuccess = function() {
        $('#learn-more-container', that.getContentElt()).html(
            el8.template.app.onboarding.learnMore.successContent()
        ).removeClass('imageLoading');
        that.adjustPosition();
    };
    that._showError = function() {
        $('#learn-more-container', that.getContentElt()).html(
            el8.template.app.onboarding.learnMore.errorContent()
        ).removeClass('imageLoading');
        that.adjustPosition();
    };

    return that;

})();
